module.exports = __webpack_public_path__ + "static/media/Screenshot_5.bb1a840d.png";